export enum ModalCloseButtonStyle {
    InsideDialog,
    OutsideDialog,
    Hidden,
}
